// removed by extract-text-webpack-plugin
module.exports = {"AccordionList":"AccordionList-rp5hcqt36d5u2zwajwmfvvhy9u2xs9wtbsdzsn78tdnj1hw3fqw5tax8nt6gd9jnpa97rgqrf8f8vft253q123p2dc2gn759s4qtg"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/AccordionList/AccordionList.module.scss
// module id = 1788
// module chunks = 0